import {Component, Inject} from '@angular/core';
import {ConfirmationDialogData} from './confirmation-dialog-data';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {ConfirmationDialogResult} from './confirmation-dialog-result';

@Component({
  selector: 'app-confirmation-dialog',
  template: `<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.text}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onOk()" tabindex="2">Ok</button>
  <button mat-button (click)="onCancel()" tabindex="-1">Cancel</button>
</div>
`,
  styles: [``]
})
export class ConfirmationDialogComponent {

  constructor(private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData) {
  }

  onCancel() {
    this.dialogRef.close(new ConfirmationDialogResult(false));
  }

  onOk() {
    this.dialogRef.close(new ConfirmationDialogResult(true));
  }
}
